<template>
  <div>
    <div class="d-flex justify-content-between">
      <download-excel :data="searchLogs"
        :fields="csvFields"
        type="csv">
        <b-button class="export-btn">Export to CSV</b-button>
      </download-excel>
      <div class="table-search ms-3">
        <div class="form-search d-flex">
          <input id="users-search-input" type="text"
            v-model="searchValue"
            class="form-control-search main-form-control @error('search') is-invalid @enderror"
            name="search" placeholder="Search by Full Name, Email, Phone">
        </div>
      </div>
    </div>
    <b-table class="table-responsive"
      striped
      :items="searchLogs"
      :fields="searchLogsFields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      responsive="lg"
      :per-page="perPage"
      :current-page="currentPage">
    </b-table>
    <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        align="right"
        aria-controls="my-table"
      ></b-pagination>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "SearchLogs",
  data: () => ({
    url: '/admin/ajax/search-logs',
    searchLogs: [],
    searchValue: '',
    sortDesc: false,
    perPage: 50,
    currentPage: 1,
    sortBy: 'id',
    csvFields: {
        id: "id",
        Query: "query",
        Location: "location",
        For_date: "for_date",
        Search_date: "search-date",
        Count_find_users: "count_find_users",
        Count_visit_profile: "count_visit_profile"
    },
    searchLogsFields: [{ key:"id", sortable: true}, { key:"query", sortable:true }, { key:"location", sortable:true },
        { key: "for_date", sortable: true }, { key:  "search-date", sortable: true }, { key:  "count_find_users", sortable: true },
        { key:  "count_visit_profile", sortable: true }],
  }),
  computed: {
      rows() {
        return this.searchLogs.length
      },
    },
  async created () {
    const response = await axios.post(this.url)
    this.searchLogs = response.data;
  }
}
</script>
